document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-card-media-prev], [data-card-media-next]');

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const productCard = button.closest('[data-product-card]');

  if (!productCard) return;

  const images = Array.from(productCard.querySelectorAll('[data-card-image]'));
  const imageCount = images.length;

  if (imageCount < 2) return;

  const currentIndex = Number(productCard.getAttribute('data-card-image-index') || 0);
  const direction = button.hasAttribute('data-card-media-next') ? 1 : -1;
  const nextIndex = (currentIndex + direction + imageCount) % imageCount;

  images.forEach((image, index) => {
    image.classList.toggle('is-active', index === nextIndex);
  });

  productCard.setAttribute('data-card-image-index', String(nextIndex));
});
